import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Grid, Button, Typography, Divider } from "@mui/material";
import * as actionType from "../../../redux/actionTypes/csaSignup";
import { connect } from "react-redux";
import { mapStateToProps } from "../../../redux/reducers";
import { Card, Box
} from "@mui/material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Form, Row } from "react-bootstrap"
import { useForm } from "react-hook-form";
import dayjs from "dayjs";
import {  Col } from "react-bootstrap";
import { convertUTCDateToLocalDate, popUpAlert, twoDigitdecNum } from "../../../utils/globalMethods";
// import document from "../../../assets/csa_roles_responsibility/CSA Attestations.pdf";
import CommonLoading from "../../common/components/commonLoading";
import moment from 'moment';
 
function SignSubmitComponent(props) {
  let loginId = props?.userAuth?.user?.id; //searchParams.get("loginId");
  // eslint-disable-next-line no-unused-vars
  const [isLoggin] = useState(loginId);
  const [signReadonly, setSignReadonly] = useState(false);
  const [isESignExist, setIsESignExist] = useState(false);
  const [showAttestations, setShowAttestations] = useState(false);
  const [isLoading] = useState();
  const [isSubmitClick, setIsSubmitClick] = useState();
  const [language, setLanguage] = useState({});
  const [eSignId, setESignId] = useState();
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors },
  } = useForm();

  // useEffect(()=>{   
  //   if (isLoggin) {
  //     const sign = {
  //       "signature": data?.sign,
  //       "isESignExist": "N",
  //     } 
  //     props.setSignature(sign);
  //   }
  // },[isLoggin]);

  const userRole = props?.userAuth?.user ? props?.userAuth?.user : JSON.parse(sessionStorage.getItem("userData"));

    useEffect(() => {
      setLanguage(props.signupLanguage)
    }, [props.signupLanguage]);

  useEffect(() => {
    if (props.csaSignup?.eSign?.code === "15") {
      setValue("sign", "");
      setESignId(0);
      setSignReadonly(true);
      setIsESignExist(false);
      if (isSubmitClick) {
        popUpAlert({
          text: "Esign Id does not exist. Please resubmit the form",
          icon: 'warning',
          timer: 2000
        });
        setIsSubmitClick(false);
      }
    } else if (props.csaSignup?.eSign?.code === "200") {
      if (props.csaSignup?.eSign?.lastUpdtTs && props.csaSignup?.eSign?.message) {
        const signedDate = convertUTCDateToLocalDate(moment(props.csaSignup?.eSign?.lastUpdtTs, "YYYY-MM-DDTHH:mm:ss[Z]").format('MM/DD/YYYY h:mm A')); //convertUTCDateToLocalDate2(new Date(props.csaSignup?.eSign?.lastUpdtTs));
        let signTs = signedDate.split(" ");
        let message = props.csaSignup?.eSign?.message;
        message = message.replace("%sdate%s", signTs?.[0]).replace("%stime%s", signTs?.[1] + " " + signTs?.[2]);
        setValue("sign", message);
        setESignId(props.csaSignup?.eSign?.id);
        setSignReadonly(true);
        setIsESignExist(true);
        if (isSubmitClick) {
          props.setIsSignSubmit(true);
          const sign = {
            "signature": message,
            "isESignExist": "Y",
            "eSignId": userRole.Role === "ADMIN" ? props.csaSignup?.eSign?.id : 0
          }
          props.setSignature(sign);
        }
      }
    }
  }, [props.csaSignup?.eSign]);

  const onSubmit = () => {
    setIsSubmitClick(true);  
    if (showAttestations && getValues("sign")) {
      props.setIsSignSubmit(true);
      const sign = {
        "signature": getValues("sign"),
        "isESignExist": isESignExist ? "Y" : "N",
        "eSignId": userRole.Role === "ADMIN" ? eSignId : 0
      }
      props.setSignature(sign);
    } else {
      // if (isLoggin && isLoggin > 0) {
      if (userRole.Role === "ADMIN") {
        const payload = {
          "firstName": props?.clientInfo?.firstName,
          "lastName": props?.clientInfo?.lastName,
          "apid": props?.clientInfo?.apid,
          "date": dayjs().format("YYYY-MM-DD"),
        }
        props.getSignature(payload);
      }
    }
  };

  useEffect(() => {
    // if (isLoggin && isLoggin > 0) {
    if (userRole.Role === "ADMIN") {
      const payload = {
        "firstName": props?.clientInfo?.firstName,
        "lastName": props?.clientInfo?.lastName,
        "apid": props?.clientInfo?.apid,
        "date": dayjs().format("YYYY-MM-DD"),
      }
      props.getSignature(payload);
    }
  // }, [isLoggin]);
  },[userRole]);

  const Attestations = () => {
    // props.setIsSignSubmit(false);
    setShowAttestations(!showAttestations)
  }

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      {isLoading && <CommonLoading />}
      <Grid item lg={12} md={12} ml={4} className='heading-grid' id="submit-signup" sx={{ mt: 7.2, border: '1px solid #CCCCCC' }}>
        <Box sx={{ backgroundColor: '#EEEEEE', borderBottom: '1px solid #CCCCCC' }}>
          <Typography variant="h3" xs={{ fontFamily: "texta-bold" }} className='sub-heading' tabIndex={0}>
            {language.signAndSubmit}
          </Typography>
        </Box>
        <Grid item xs={12} p={1} sx={{ borderRadius: "5px", backgroundColor: "#DBE8DF", fontSize: "20px", fontFamily: 'Texta-bold', width:'80%', marginLeft:'1.7rem', marginTop:'0.8rem' }}>
          <Typography className="snap-title">{language.upcomingMonthlyCSA}</Typography>
            <Divider sx={{ borderWidth: 1, backgroundColor: "#006e52", width: '70px' }} />
              <Grid sx={{ display: 'flex', flexDirection: 'row' }}>
                <Typography sx={{
                        fontFamily: 'Texta-book', fontSize: '20px', fontWeight: 400,
                        lineHeight: "1.5"
                }}>
                  {props?.farmInfo?.farmDetails?.isHIPVendor === "N" ? language.payWithSNAP : language.payWithSNAPHIP}
                  </Typography>
                  <Typography className="snap-info">&nbsp;${twoDigitdecNum(props?.totalShareCost)}</Typography>
              </Grid>                 
        </Grid>
        {props?.farmInfo?.farmDetails?.isHIPVendor === "Y" && (
        <Grid item xs={12} p={1} sx={{ borderRadius: "5px", backgroundColor: "#DBE8DF", fontSize: "20px", fontFamily: 'Texta-bold', width:'80%', marginLeft:'1.7rem', marginTop:'0.8rem' }}>
          <Typography  className="snap-title">
          {language.amountOfHIP} = <span className="snap-info">${parseFloat(props?.totalShareCost) > parseFloat(props?.clientInfo?.hipAmount) ? twoDigitdecNum(props?.clientInfo?.hipAmount) : twoDigitdecNum(props?.totalShareCost)}</span>
            </Typography>               
        </Grid>
        )}
        <Grid container>
          <Card style={{ color: 'white', height: 'auto', boxShadow: "none", borderRadius: 0 }}>
            {!showAttestations &&
              <Col xs={12} className="jumbotron" style={{ alignContent: 'center', height: 'auto' }}>
                <div className="csa-rights-card">
                  <h4 className="csa-rights" tabIndex={0}>{language.CSARights}</h4>
                  <Grid className="submit-content"  style={{ maxHeight: '300px', overflowY: 'scroll'}} tabIndex="0">
                    <ul className="csa-submit-ul-li">

                      <li>{language.ThePaymentScheduleShown}</li>
                      <li>{language.TheFarmDecidesWhether}</li>
                      <li>{language.BenefitsWillBe}</li>
                      <li>{language.MysignupInformation}</li>
                      <li>{language.IAmResponsible}</li>
                      <li>{language.TheType}</li>
                      <li>{language.IfMySNAP}</li>
                      <li>{language.CSAShareDetails}</li>
                      <li>{language.IMayCancel}<br />
                              <ul style={{ paddingLeft:'45px'}}>
                                  <li style={{ listStyleType:'circle'}}> {language.Submitting} </li>
                                  <li style={{ listStyleType:'circle'}}> {language.Calling}</li>
                              </ul>
                        {language.CancellationsMust}</li>
                      <li>
                        {language.IMayBeAsked}</li>
                    </ul>
                  </Grid>
                </div>
              </Col>}
              <Grid style={{ marginTop: '10px', display:"flex" }}>
                <input style={{ position: 'relative', left: '50px'}} 
                  {...register("terms", { required: true })}
                  id="terms_conditions" type="checkbox" onClick={Attestations} />
                <button type="checkbox" className="checkbox" aria-label="Accept terms and conditions"><label htmlFor="terms_conditions">{language.IHaveReadTheTerms}</label></button>
                </Grid>
                <div style={{ marginTop: '10px',marginLeft:'18px'}}>
                  {errors.terms && (
                    <span className="dh-txt-danger" role="alert" aria-live="assertive"><i className="fa fa-info-circle"></i> {language.PleaseCheckTermsError}</span>
                  )}
              </div>
          </Card>
        </Grid>
        <Grid pl={4} style={{ display: "flex", flexDirection: "row", height: '180px', backgroundColor: 'EEEEEE' }}>
          <Row>
            <Col>
              <Form.Label className="client-signature">{language.Date}</Form.Label>
            <Typography sx={{ fontFamily: "Texta-book", marginTop: '15px', fontSize: '20px' }}>{dayjs().format("MM/DD/YYYY")}</Typography>
            </Col>
            <Col md={8} xs={12}>
            <Form.Label className="client-signature">{language.ClientSignature} <span className="sr-only">required</span><span aria-hidden="true">*</span></Form.Label>
            <Form.Control
              style={{ border: '1px solid #adb5bd'}}
              aria-label="client Signature"
              {...register("sign", { required: !signReadonly })}
              className={signReadonly ? "grey signsubmit" : "signsubmit"}
              readOnly={signReadonly}
            />

          </Col>
          {errors.sign && (
            <span className="dh-txt-danger" role="alert" aria-live="assertive"><i className="fa fa-info-circle"></i>  {language.SignatureErrorMsg}</span>
          )}
          </Row>
        </Grid>
        <Grid container direction="row" alignItems={'center'} justifyContent={'space-between'} sx={{ border: '1px solid rgba(0, 0, 0, 0.125)', borderTop: 'none', backgroundColor: "#EEEEEE", height: '80px', padding: '16px' }}>
          <Grid><Button aria-label="previous" onClick={() => {
              props.setActiveTab("menuStep4");
              props.setCSAFormValidate((prevState) => ({
                ...prevState,
                sign_submit: signReadonly || getValues("sign") != "" ? true : false
              }));
            }}
              sx={{
                backgroundColor: '#ffffff', color: '#006E52', height: '50px', width: '100px', borderColor: '#006E52', border: 'solid', borderWidth: '1px', '&:hover': {
                  backgroundColor: '#006E52',
                  color: '#ffffff',
                },
                '&:active': {
                  backgroundColor: '#006E52',
                  color: '#ffffff',
                },
              }}>
              <ArrowBackIosNewIcon />{language.Prev}
            </Button></Grid>
            <Grid><Button type="submit" disabled={isLoading} sx={{ backgroundColor: '#006E52 !important', display: 'flex', alignItems: 'end', color: 'white', padding: '10px', fontFamily: 'Texta-bold !important', letterSpacing: 'normal', fontSize: '18px' }} >
              {language.SubmitApplication}
            </Button>
          </Grid>
        </Grid>
      </Grid>

    </Form >
  );
}
SignSubmitComponent.propTypes = {
  setActiveTab: PropTypes.func.isRequired,
  signature: PropTypes.object,
  setSignature: PropTypes.func,
  setCSAFormValidate: PropTypes.func.isRequired,
  getSignature: PropTypes.func.isRequired,
  clientInfo: PropTypes.object,
  csaSignup: PropTypes.object,
  setIsSignSubmit: PropTypes.func.isRequired,
  userAuth: PropTypes.object.isRequired,
  totalShareCost: PropTypes.object,
  farmInfo: PropTypes.object,
  signupLanguage: PropTypes.object,

}

function mapDispatchToProps(dispatch) {
  return {
    getSignature: (payload) => dispatch(actionType.getSignature(payload)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignSubmitComponent);